import React from "react";
import HeroCarousel from "../components/HeroCarousel";
import { FeatureStrip, AboutIntro, WhyChoose, MissionVisionValues, CertificationsPreview } from "../components/HomeSections";
import ProductShowcase from "../components/ProductShowcase";
import StatsBar from "../components/StatsBar";
import Testimonials from "../components/Testimonials";
import BlogTeaser from "../components/BlogTeaser";
import SEO from "../components/SEO";

const Home = () => (
  <>
    <SEO
      title="Rudrash Private Limited — Pioneering Sustainable Agriculture in Eastern India"
      description="Rudrash Private Limited cultivates premium mushrooms, saffron and poultry through controlled-environment and aeroponic farming in Kolkata, West Bengal."
    />
    <div data-testid="page-home">
      <HeroCarousel />
      <FeatureStrip />
      <AboutIntro />
      <ProductShowcase />
      <StatsBar />
      <WhyChoose />
      <CertificationsPreview />
      <MissionVisionValues />
      <Testimonials />
      <BlogTeaser />
    </div>
  </>
);

export default Home;
